import { render, staticRenderFns } from "./oderDet.vue?vue&type=template&id=67665b44&"
import script from "./oderDet.vue?vue&type=script&lang=js&"
export * from "./oderDet.vue?vue&type=script&lang=js&"
import style0 from "./oderDet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports